import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { LeadInterface } from 'app/module/lead-interface';

@Injectable({
	providedIn: 'root'
})
export class LeadService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	private httpOptionsNoAuth = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			// 'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public findAll(): Observable<LeadInterface[]> {
		return this.http.get<LeadInterface[]>(`${this.url}lead`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public findOne(id_lead: number): Observable<any> | undefined {
		return this.http.get<any>(`${this.url}lead/${id_lead}`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	public create(data: any): Observable<any> {
		return this.http
			.post<any>(`${this.url}lead/create/externo`, data, this.httpOptionsNoAuth)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public update(data: any, id: number): Observable<LeadInterface> {
		return this.http.put<any>(`${this.url}lead/${id}`, data, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public getCpf(documento: number): Observable<any> {
		return this.http
			.get<any>(`${this.url}lead/cpf/${documento}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	public tornarCliente(id_lead: any): Observable<any> {
		return this.http
			.put<any>(`${this.url}lead/cliente/${id_lead}`, this.httpOptions)
			.pipe(
				(res) => res,
				(error) => error
			);
	}

	// public remove(data: number, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}sistema/${id}/update`, {
	// 			id_sistema: id,
	// 			isDeleted: data,
	// 		})
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }
}
